<i18n>
    [
        "global__off",
        "product__prepurchase--salePriceSubtext",
    ]
</i18n>

<template>
    <div class="c-product-pre-purchase">
        <div class="u-spacer--1">
            <span class="c-product-pre-purchase__pre-purchase-pricing o-text--heading-1">
                {{ prePurchaseSalePrice }}
            </span>
            <span class="c-product-pre-purchase__strike-through u-text--gray">
                {{ retailPrice }}
            </span>
            <span class="u-text--gray">
                {{ discountPercentage }}
            </span>
        </div>
        <div class="o-text--caption u-text--gray">
            {{ salePriceSubtext }}
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

import { useFilters } from '~coreModules/core/js/custom-filters';
import { useI18n } from 'vue-i18n';

const props = defineProps({
    prePurchaseProduct: {
        type: Object,
        required: true,
    },
});

const filters = useFilters();
const { t } = useI18n();

const globalOffText = computed(() => t('global__off'));
const prePurchaseSalePrice = computed(() => (
    filters.i18nFormatDollarsNoCents(props.prePurchaseProduct?.salePrice)
));
const retailPrice = computed(() => filters.i18nFormatDollarsNoCents(props.prePurchaseProduct?.listPrice));
const discountPercentage = computed(() => `(${props.prePurchaseProduct?.discountPercent}% ${globalOffText.value})`);
const salePriceSubtext = computed(() => t('product__prepurchase--salePriceSubtext'));

</script>

<style lang="scss">
.c-product-pre-purchase {
    display: flex;
    flex-direction: column;

    &__strike-through {
        margin-left: $nu-spacer-1;
        margin-right: $nu-spacer-0pt5;
        text-decoration: line-through;
    }
}
</style>
